import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { LoginPage, ReferPage } from './pages';
import { DashboardPage } from './pages/DashboardPage/DashboardPage';
import { ProtectedRoute } from './ProtectedRoute';
import { SupplierIndexRedirect } from './components/general/SupplierIndexRedirect/SupplierIndexRedirect';
import { Suppliers } from './components/modules/suppliers/Suppliers/Suppliers';
import { ViewSupplierInvoices } from './components/modules/suppliers/ViewSupplierInvoices/ViewSupplierInvoices';
import { Customers } from './components/modules/customers/Customers/Customers';
import { CustomerDetails } from './components/modules/customers/CustomerDetails/CustomerDetails';
// import SupplierInvoices from './components/modules/suppliers/SupplierInvoices/SupplierInvoices';
import ManualUploadInvoices from './components/modules/suppliers/ManualUploadInvoices/ManualUploadInvoices';
import { BuyerPayments } from './components/modules/payments/BuyerPayments/BuyerPayments';
import { SupplierPayments } from './components/modules/payments/SupplierPayments/SupplierPayments';
import { HelpPage } from './components/modules/help/HelpPage/HelpPage';
import SupplierSalesReceipts from './components/modules/suppliers/SupplierSalesReceipts/SupplierSalesReceipts';
import LienWaivers from './components/modules/lienWaivers/supplier/LienWaivers/LienWaivers';
import LienWaiverDocumentView from './components/modules/lienWaivers/supplier/LienWaiverDocumentView/LienWaiverDocumentView';
import BuyerLienJobs from './components/modules/lienWaivers/buyerLiens/BuyerLienJobs/BuyerLienJobs';
import BuyerLienSuppliers from './components/modules/lienWaivers/buyerLiens/BuyerLienSuppliers/BuyerLienSuppliers';
import BuyerLienTemplates from './components/modules/lienWaivers/buyerLiens/BuyerLienTemplates/BuyerLienTemplates';
import BuyerLienReleases from './components/modules/lienWaivers/buyerLiens/BuyerLienReleases/BuyerLienReleases';
import BuyerAddLienRelease from './components/modules/lienWaivers/buyerLiens/BuyerAddLienRelease/BuyerAddLienRelease';
import BuyerEditLienRelease from './components/modules/lienWaivers/buyerLiens/BuyerEditLienRelease/BuyerEditLienRelease';
import BuyerTemplatesFields from './components/modules/lienWaivers/buyerLiens/BuyerTemplatesFields/BuyerTemplatesFields';
import BuyerAddLienTemplate from './components/modules/lienWaivers/buyerLiens/BuyerAddLienTemplate/BuyerAddLienTemplate';
import BuyerReleaseJobDetails from './components/modules/lienWaivers/buyerLiens/BuyerReleaseJobDetails/BuyerReleaseJobDetails';
import NoticeTemplates from './components/modules/suppliers/NoticeTemplates/NoticeTemplates';
import AddNoticeTemplate from './components/modules/suppliers/AddNoticeTemplate/AddNoticeTemplate';
import NoticeTemplatesFields from './components/modules/suppliers/NoticeTemplatesFields/NoticeTemplatesFields';
import PreliminaryNotices from './components/modules/suppliers/PreliminaryNotices/PreliminaryNotices';
import AddPreliminaryNotice from './components/modules/suppliers/AddPreliminaryNotice/AddPreliminaryNotice';
import RootSetupPage from './pages/RootSetupPage/RootSetupPage';
import { ReferSetupPage } from './pages/ReferSetupPage/ReferSetupPage';
import BuyerManualAddLienRelease from './components/modules/lienWaivers/buyerLiens/BuyerManualAddLienRelease/BuyerManualAddLienRelease';
import SupplierJobs from './components/modules/suppliers/SupplierJobs/SupplierJobs';
import SupplierJobDetails from './components/modules/suppliers/SupplierJobDetails/SupplierJobDetails';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';
import RequestJobInformationSheet from './pages/RequestJobInformationSheet/RequestJobInformationSheet';
import EditPreliminaryNotice from './components/modules/suppliers/EditPreliminaryNotice/EditPreliminaryNotice';
import AddManualPrelimNotice from './components/modules/suppliers/AddManualPrelimNotice/AddManualPrelimNotice';
import PaymentRequests from './components/modules/suppliers/PaymentRequests/PaymentRequests';
import PaymentRequestPaymentPage from './pages/PaymentRequestPaymentPage/PaymentRequestPaymentPage';
import SupplierReporting from './components/modules/suppliers/SupplierReporting/SupplierReporting';
import Liens from './components/modules/suppliers/FiledLiens/FiledLiens';
import FiledLienTemplates from './components/modules/suppliers/FiledLienTemplates/FiledLienTemplates';
import AddFiledLienTemplate from './components/modules/suppliers/AddFiledLienTemplate/AddFiledLienTemplate';
import FiledLienTemplatesFields from './components/modules/suppliers/FiledLienTemplatesFields/FiledLienTemplatesFields';
import AddFiledLien from './components/modules/suppliers/AddFiledLien/AddFiledLien';
import EditFiledLien from './components/modules/suppliers/EditFiledLienNotice/EditFiledLienNotice';
import VirtualPOS from './components/modules/suppliers/VirtualPOS/VirtualPOS';
import { CreditApplicationRequest } from './components/modules/creditApplication/CreditApplicationRequest/CreditApplicationRequest';
import CreditApplication from './components/modules/creditApplication/CreditApplicationTemplate/CreditApplicationTemplates';
import AddCreditApplicationTemplate from './components/modules/creditApplication/CreditApplicationTemplate/AddCreditTemplate';
import EditCreditApplicationTemplate from './components/modules/creditApplication/CreditApplicationTemplate/EditCreditTemplate';
import { PreviewCreditApplicationForm } from './components/modules/creditApplication/CreditApplicationTemplate/PreviewCreditApplicationForm';
import { ReviewAndSignCreditApplication } from './components/modules/creditApplication/ReviewAndSignCreditApplications/ReviewAndSignCreditApplication';
import { SignInternalSignatureDocument } from './components/modules/creditApplication/SignInternalSignatureDocument/SignInternalSignatureDocument';
import { FillInternalForm } from './components/modules/creditApplication/InternalForms/FillInternalForm';
import InternalFormSubmissions from './components/modules/creditApplication/InternalForms/InternalFormSubmissions';
import InternalFormSubmissionDetails from './components/modules/creditApplication/InternalForms/InternalFormSubmissionDetails';
import CreditApplications from './components/modules/creditApplication/CreditApplications/CreditApplications';
import CreditApplicationDetails from './components/modules/creditApplication/CreditApplicationDetails/CreditApplicationDetails';
import CreditApplicationManualUpload from './components/modules/creditApplication/CreditApplicationManualUpload/CreditApplicationManualUpload';
import { ReviewAndUpdateCreditApplications } from './components/modules/creditApplication/ReviewAndUpdateCreditApplications/ReviewAndUpdateCreditApplications';
import { CreditApplicationReference } from './components/modules/creditApplication/CreditApplicationReference/CreditApplicationReference';
import SSOCompletePage from './pages/SSOCompletePage/SSOCompletePage';
import CreditApplicationsMonitor from './components/modules/creditApplication/CreditApplicationsMonitor/CreditApplicationsMonitor';
import CreditApplicationMonitorDetails from './components/modules/creditApplication/CreditApplicationMonitorDetails/CreditApplicationMonitorDetails';
import { ManualAddApplication } from './components/modules/creditApplication/ManualAddApplication/ManualAddApplication';
import SupplierSettings from './components/modules/customers/Customers/SupplierSettings/SupplierSettings';
import { CashApplicationReviewQueue } from './components/modules/cashApplication/ReviewQueue/ReviewQueue';
import { CashApplicationPostHistory } from './components/modules/cashApplication/PostHistory/PostHistory';
import { CashApplicationDataIntegrations } from './components/modules/cashApplication/DataIntegrations/DataIntegrations';
import { CashApplicationSettings } from './components/modules/cashApplication/CashApplicationSettings/CashApplicationSettings';
import SupplierDisputes from './components/modules/suppliers/SupplierDisputes/SupplierDisputes';
import SupplierCollectionTasks from './components/modules/suppliers/SupplierCollectionTasks/SupplierCollectionTasks';
import SupplierPromiseToPays from './components/modules/suppliers/SupplierPromiseToPays/SupplierPromiseToPays';
import SupplierCollectionTriggersAndSequences from './components/modules/suppliers/CollectionTriggersAndSequences/SupplierCollectionTriggersAndSequences';
import CollectionSequenceDetails from './components/modules/suppliers/CollectionTriggersAndSequences/CollectionSequenceDetails';
import SupplierInvoiceDelivery from './components/modules/suppliers/SupplierInvoiceDelivery/SupplierInvoiceDelivery';
import { CreditApplicationUpdateReferenceEmail } from './components/modules/creditApplication/CreditApplicationUpdateReferenceEmail/CreditApplicationUpdateReferenceEmail';
import TradeReferencesPool from './components/modules/creditApplication/TradeReferencesPool/TradeReferencesPool';
import MainBuyerUserProfile from './components/modules/userProfiles/MainBuyerUserProfile/MainBuyerUserProfile';
import SupplierUserProfile from './components/modules/userProfiles/SupplierUserProfile/SupplierUserProfile';
import BuyerReporting from './components/modules/mainBuyers/BuyerReporting/BuyerReporting';
import ApprovalWorkflows from './components/modules/creditApplication/ApprovalWorkflows/ApprovalWorkflows';
import CreditApplicationsDashboard from './components/modules/creditApplication/CreditApplicationsDashboard/CreditApplicationsDashboard';
import SupplierPaymentsDashboard from './components/modules/payments/supplierPaymentsDashboard/SupplierPaymentsDashboard';
import { MainBuyerDashboard } from './components/modules/mainBuyers/MainBuyerDashboard/MainBuyerDashboard';
import { MainBuyerPaymentPlan } from './components/modules/payments/MainBuyerPaymentPlan/MainBuyerPaymentPlan';
import MainBuyerStatementInvoice from './components/modules/mainBuyers/MainBuyerStatementInvoices/MainBuyerStatementInvoice';

function AppRouter() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <RootSetupPage redirectToPath="/login" />,
      // element: <Navigate to="/login" />,
    },
    // {
    //   path: '/?*',
    //   element: <RootSetupPage redirectToPath="/login" />,
    // },
    {
      path: 'help/*',
      element: (
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      ),
      children: [
        {
          path: '',
          element: (
            <ProtectedRoute>
              <HelpPage />
            </ProtectedRoute>
          ),
        },
      ],
    },
    {
      path: 'lienReleases/*',
      element: (
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      ),
      children: [
        {
          path: '',
          element: <LienWaivers />,
        },
        {
          path: ':lienReleaseId',
          element: <LienWaiverDocumentView />,
        },
      ],
    },

    {
      path: '/supplier',
      element: (
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      ),
      children: [
        // Add id-less supplier routes here as siblings of ':supplierId',
        // e.g. { path: 'select', element: <SupplierPicker /> } -> /supplier/select
        {
          index: true,
          element: (
            <ProtectedRoute>
              <SupplierIndexRedirect />
            </ProtectedRoute>
          ),
        },
        {
          path: ':supplierId',
          children: [
            {
              path: 'supplierJobs/*',
              children: [
                {
                  path: '',
                  element: <SupplierJobs />,
                },
                {
                  path: ':supplierJoId',
                  element: <SupplierJobDetails />,
                },
              ],
            },
            {
              path: 'invoices/*',
              children: [
                {
                  path: '',
                  element: <ManualUploadInvoices />,
                },
              ],
            },
            {
              path: 'salesReceipts/*',
              children: [
                {
                  path: '',
                  element: <SupplierSalesReceipts />,
                },
              ],
            },
            {
              path: 'creditApplications/*',
              children: [
                {
                  path: '',
                  element: <CreditApplications />,
                },
                {
                  path: ':creditApplicationId',
                  element: <CreditApplicationDetails />,
                },
                {
                  path: 'overview/manualUploadCreditApplication',
                  element: <CreditApplicationManualUpload />,
                },
                {
                  path: 'manualAddCreditApplication/:templateId',
                  element: <ManualAddApplication />,
                },
                {
                  path: 'internalForms',
                  element: <InternalFormSubmissions />,
                },
                {
                  path: 'internalForms/:internalFormSubmissionId',
                  element: <InternalFormSubmissionDetails />,
                },
              ],
            },
            {
              path: 'tradeReferencesPool/*',
              children: [
                {
                  path: '',
                  element: <TradeReferencesPool />,
                },
              ],
            },
            {
              path: 'dashboardCreditApplications/*',
              children: [
                {
                  path: '',
                  element: <CreditApplicationsDashboard />,
                },
              ],
            },
            {
              path: 'dashboardPayments/*',
              children: [
                {
                  path: '',
                  element: <SupplierPaymentsDashboard />,
                },
              ],
            },
            {
              path: 'approvalWorkflows/*',
              children: [
                {
                  path: '',
                  element: <ApprovalWorkflows />,
                },
              ],
            },
            {
              path: 'creditMonitoring/*',
              children: [
                {
                  path: '',
                  element: <CreditApplicationsMonitor />,
                },
                {
                  path: ':creditApplicationMonitorId',
                  element: <CreditApplicationMonitorDetails />,
                },
              ],
            },
            {
              path: 'customers/*',

              children: [
                {
                  path: '',
                  element: <Customers />,
                },
                {
                  path: ':customerId',
                  element: <CustomerDetails />,
                },
              ],
            },
            {
              path: 'reports/*',
              children: [
                {
                  path: '',
                  element: <SupplierReporting />,
                },
              ],
            },
            {
              path: 'settings/*',
              children: [
                {
                  path: '',
                  element: <SupplierSettings />,
                },
              ],
            },
            {
              path: 'help/*',
              children: [
                {
                  path: '',
                  element: <HelpPage />,
                },
              ],
            },
            {
              path: 'payments/*',
              children: [
                {
                  path: '',
                  element: <SupplierPayments />,
                },
              ],
            },
            {
              path: 'cashApplication/*',
              children: [
                {
                  path: '',
                  element: <CashApplicationReviewQueue />,
                },
                {
                  path: 'postHistory',
                  element: <CashApplicationPostHistory />,
                },
                {
                  path: 'dataIntegrations',
                  element: <CashApplicationDataIntegrations />,
                },
                {
                  path: 'settings',
                  element: <CashApplicationSettings />,
                },
              ],
            },
            {
              path: 'virtualPOS/*',
              children: [
                {
                  path: '',
                  element: <VirtualPOS />,
                },
              ],
            },
            {
              path: 'preliminaryNotices/*',
              children: [
                {
                  path: 'overview',
                  element: <PreliminaryNotices />,
                },
                {
                  path: 'overview/addPreliminaryNotice',
                  element: <AddPreliminaryNotice />,
                },
                {
                  path: 'overview/editPreliminaryNotice/:preliminaryNoticeId',
                  element: <EditPreliminaryNotice />,
                },
                {
                  path: 'overview/manualAddPreliminaryNotice',
                  element: <AddManualPrelimNotice />,
                },
              ],
            },

            {
              path: 'liens/*',
              children: [
                {
                  path: 'overview',
                  element: <Liens />,
                },
                {
                  path: 'overview/addLien',
                  element: <AddFiledLien />,
                },
                {
                  path: 'overview/editLien/:lienId',
                  element: <EditFiledLien />,
                },
              ],
            },
            {
              path: 'noticeTemplates/*',
              children: [
                {
                  path: 'templates',
                  element: <NoticeTemplates />,
                },
                {
                  path: 'templates/addTemplate',
                  element: <AddNoticeTemplate />,
                },
              ],
            },
            {
              path: 'noticeTemplateFields',
              children: [
                {
                  path: '',
                  element: <NoticeTemplatesFields />,
                },
              ],
            },
            {
              path: 'lienTemplates/*',
              children: [
                {
                  path: 'templates',
                  element: <FiledLienTemplates />,
                },
                {
                  path: 'templates/addTemplate',
                  element: <AddFiledLienTemplate />,
                },
              ],
            },
            {
              path: 'lienTemplateFields',
              children: [
                {
                  path: '',
                  element: <FiledLienTemplatesFields />,
                },
              ],
            },
            {
              path: 'paymentRequests',
              children: [
                {
                  path: '',
                  element: <PaymentRequests />,
                },
              ],
            },
            {
              path: 'disputes',
              children: [
                {
                  path: '',
                  element: <SupplierDisputes />,
                },
              ],
            },
            {
              path: 'collectionTasks',
              children: [
                {
                  path: '',
                  element: <SupplierCollectionTasks />,
                },
              ],
            },
            {
              path: 'promiseToPays',
              children: [
                {
                  path: '',
                  element: <SupplierPromiseToPays />,
                },
              ],
            },
            {
              path: 'collectionSequencesAndTriggers',
              children: [
                {
                  path: '',
                  element: <SupplierCollectionTriggersAndSequences />,
                },
                {
                  path: ':sequenceId',
                  element: <CollectionSequenceDetails />,
                },
              ],
            },
            {
              path: 'invoiceDelivery',
              children: [
                {
                  path: '',
                  element: <SupplierInvoiceDelivery />,
                },
              ],
            },
            {
              path: 'profile',
              children: [
                {
                  path: '',
                  element: <SupplierUserProfile />,
                },
              ],
            },

            {
              path: 'creditApplicationRequestTemplates',
              children: [
                {
                  path: 'overview',
                  element: <CreditApplication />,
                },
                {
                  path: 'overview/addCreditApplicationRequestTemplate',
                  element: <AddCreditApplicationTemplate />,
                },
                {
                  path: 'previewApplication/*',
                  element: <PreviewCreditApplicationForm />,
                },
                {
                  path: 'overview/*',
                  element: <EditCreditApplicationTemplate />,
                },
              ],
            },
          ],
        },
      ],
    },

    {
      path: 'companies',
      element: (
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      ),
      children: [
        {
          path: '',
          element: <Suppliers />,
        },
      ],
    },

    {
      path: '/companies/:mainBuyerId',
      element: (
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      ),
      children: [
        {
          path: '',
          element: (
            <ProtectedRoute>
              <Suppliers />
            </ProtectedRoute>
          ),
        },
        {
          path: 'invoices',
          element: (
            <ProtectedRoute>
              <Suppliers />
            </ProtectedRoute>
          ),
        },
        {
          path: 'invoices',
          element: (
            <ProtectedRoute>
              <Suppliers />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mainBuyerDashboard',
          element: (
            <ProtectedRoute>
              <MainBuyerDashboard />
            </ProtectedRoute>
          ),
        },
        {
          path: 'statementInvoices',
          element: (
            <ProtectedRoute>
              <MainBuyerStatementInvoice />
            </ProtectedRoute>
          ),
        },

        {
          path: 'invoices/:supplierDomainId',
          element: (
            <ProtectedRoute>
              <ViewSupplierInvoices />
            </ProtectedRoute>
          ),
        },
        {
          path: 'payments',
          element: (
            <ProtectedRoute>
              <BuyerPayments />
            </ProtectedRoute>
          ),
        },
        {
          path: 'payments/:restaurantGroupId',
          element: (
            <ProtectedRoute>
              <BuyerPayments />
            </ProtectedRoute>
          ),
        },
        {
          path: 'paymentPlan',
          element: (
            <ProtectedRoute>
              <MainBuyerPaymentPlan />
            </ProtectedRoute>
          ),
        },
        {
          path: 'profile',
          element: (
            <ProtectedRoute>
              <MainBuyerUserProfile />
            </ProtectedRoute>
          ),
        },
        {
          path: 'reporting',
          element: (
            <ProtectedRoute>
              <BuyerReporting />
            </ProtectedRoute>
          ),
        },
      ],
    },
    {
      path: '/buyerLienReleases/:mainBuyerId',
      element: (
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      ),
      children: [
        {
          path: 'overview',
          element: (
            <ProtectedRoute>
              <BuyerLienReleases />
            </ProtectedRoute>
          ),
        },
        {
          path: 'overview/addLienRelease',
          element: (
            <ProtectedRoute>
              <BuyerAddLienRelease />
            </ProtectedRoute>
          ),
        },
        {
          path: 'overview/manualAddLienRelease',
          element: (
            <ProtectedRoute>
              <BuyerManualAddLienRelease />
            </ProtectedRoute>
          ),
        },
        {
          path: 'overview/editRelease/:releaseId',
          element: (
            <ProtectedRoute>
              <BuyerEditLienRelease />
            </ProtectedRoute>
          ),
        },
        {
          path: 'lienReleasesJobs',
          element: (
            <ProtectedRoute>
              <BuyerLienJobs />
            </ProtectedRoute>
          ),
        },
        {
          path: 'lienReleasesSupplier',
          element: (
            <ProtectedRoute>
              <BuyerLienSuppliers />
            </ProtectedRoute>
          ),
        },
        {
          path: 'templates',
          element: (
            <ProtectedRoute>
              <BuyerLienTemplates />
            </ProtectedRoute>
          ),
        },
        {
          path: 'templates/addTemplate',
          element: (
            <ProtectedRoute>
              <BuyerAddLienTemplate />
            </ProtectedRoute>
          ),
        },
        {
          path: 'templateFields',
          element: (
            <ProtectedRoute>
              <BuyerTemplatesFields />
            </ProtectedRoute>
          ),
        },
        {
          path: 'lienReleasesJobs/:jobId',
          element: (
            <ProtectedRoute>
              <BuyerReleaseJobDetails />
            </ProtectedRoute>
          ),
        },
        {
          path: 'lienReleasesJobs/:jobId/addRelease',
          element: (
            <ProtectedRoute>
              <BuyerAddLienRelease />
            </ProtectedRoute>
          ),
        },
        {
          path: 'lienReleasesJobs/:jobId/editRelease/:releaseId',
          element: (
            <ProtectedRoute>
              <BuyerEditLienRelease />
            </ProtectedRoute>
          ),
        },
      ],
    },
    {
      path: '/suppliers/*',
      element: (
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      ),
    },
    {
      path: '/profile',
      element: (
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      ),
    },
    {
      path: '/priceList',
      element: (
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      ),
    },
    {
      path: '/contacts',
      element: (
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      ),
    },
    {
      path: '/login',
      element: <LoginPage />,
      children: [
        {
          path: '',
          element: <LoginPage />,
        },
        {
          path: '*',
          element: <LoginPage />,
        },
      ],
    },
    {
      path: '/portal',
      element: <LoginPage />,
      children: [
        {
          path: '',
          element: <LoginPage />,
        },
        {
          path: '*',
          element: <LoginPage />,
        },
      ],
    },
    {
      path: '/refer',
      element: <ReferSetupPage />,
    },
    {
      path: '/refer/add',
      element: <ReferPage />,
    },
    {
      path: '/sso-complete',
      element: <SSOCompletePage />,
    },
    {
      path: '/*',
      element: (
        <ProtectedRoute>
          <NotFoundPage />
        </ProtectedRoute>
      ),
    },
    {
      path: '/requestJobInformation',
      element: <RequestJobInformationSheet />,
    },
    {
      path: '/requestCreditApplication',
      element: <CreditApplicationRequest />,
    },
    {
      path: '/reviewAndSignCreditApplication',
      element: <ReviewAndSignCreditApplication />,
    },
    {
      path: '/signInternalSignatureDocument',
      element: <SignInternalSignatureDocument />,
    },
    {
      path: '/fillInternalForm',
      element: <FillInternalForm />,
    },
    {
      path: '/paymentRequestPayment',
      element: <PaymentRequestPaymentPage />,
    },
    {
      path: '/paymentRequestPayment/*',
      element: <PaymentRequestPaymentPage />,
    },
    {
      path: '/reviewCreditApplicationFeedback/*',
      element: <ReviewAndUpdateCreditApplications />,
    },
    {
      path: '/referenceCreditApplication',
      element: <CreditApplicationReference />,
    },
    {
      path: '/updateReferenceCreditApplication',
      element: <CreditApplicationUpdateReferenceEmail />,
    },
  ]);

  return (
    <div className="w-full h-full">
      <RouterProvider router={router} />
    </div>
  );
}

export default AppRouter;
